export default {
  // common
  ok: 'OK',
  cancel: 'Cancel',
  send: 'Send',
  // time
  timeJustNow: 'Just now',
  timeMinutesAgo: '{n} min ago',
  timeHoursAgo: '{n} h ago',
  timeYesterday: 'Yesterday',
  // chat toolbar titles
  chatEmotion: 'Emoji',
  chatSendImage: 'Send image',
  chatSendFile: 'Send file',
  chatReceipt: 'Receipt message',
  chatSendVoice: 'Send voice',
  chatGroupInfo: 'Group info',
  // chat area
  chatSomeoneAtMe: 'Someone mentioned me',
  chatNewMessages: '{n} new messages',
  chatBackToBottom: 'Back to bottom',
  chatReceiptPrefix: '[Receipt] ',
  // message actions / tips
  chatNoMoreMessages: 'No more messages',
  chatDeleteConfirm: 'Delete this message?',
  chatDeleteTitle: 'Delete message',
  chatRecallConfirm: 'Recall this message?',
  chatRecallTitle: 'Recall message',
  chatRecalled: 'Message recalled',
  chatLocateFail: 'Unable to locate the original message',
  chatResendUnsupported: 'This message does not support auto-resend. Please resend manually.',
  // input disabled tips
  chatGroupDissolved: 'Group has been dissolved',
  chatGroupQuit: 'You are no longer in this group',
  chatGroupBanned: 'Group has been banned',
  chatUserBanned: 'This account has been banned',
  chatBanReason: ', reason: ',
  // message status / readed
  msgReaded: 'Read',
  msgUnread: 'Unread',
  msgAllReaded: 'All read',
  msgSomeReaded: 'Read by {n}',
  msgSending: 'Sending',
  msgSendFail: 'Send failed',
  msgRecall: 'Call again',
  msgMenuDelete: 'Delete',
  msgMenuRecall: 'Recall',
  // voice record
  recordTitle: 'Voice Recording',
  recordDuration: 'Duration',
  recordStart: 'Start',
  recordPause: 'Pause',
  recordResume: 'Resume',
  recordStop: 'Stop',
  recordPlay: 'Play',
  recordStopPlay: 'Stop Playing',
  recordRestart: 'Re-record',
  recordSend: 'Send Now',
  recordStateReady: 'Not started',
  recordStateRunning: 'Recording...',
  recordStatePaused: 'Recording paused',
  recordStateStopped: 'Recording stopped',
  msgReadedTab: 'Read ({n})',
  msgUnreadTab: 'Unread ({n})',
  // language
  langLabel: 'Language',
  langZh: '中文',
  langEn: 'English'
}
